import { render, staticRenderFns } from "./zoomOut.vue?vue&type=template&id=5b8d56d5&"
import script from "./zoomOut.vue?vue&type=script&lang=js&"
export * from "./zoomOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports